import axios from 'axios';
import {settings} from '@/plugins/settings';

export interface IMayordomoUser {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
}

// Mayordomo's own users search (GET users?search=, the one the users list uses): it matches
// name, email, id or phone and returns at most 15 users. It ignores queries under 3 chars.
export const USER_SEARCH_MIN_LENGTH = 3;

export function searchMayordomoUsers(search: string): Promise<IMayordomoUser[]> {
  const q = search.trim();
  if (q.length < USER_SEARCH_MIN_LENGTH) return Promise.resolve([]);

  return axios({url: settings.endpoint + 'users', method: 'GET', params: {search: q}})
    // Response shape: {data: {data: [...]}}
    .then((res: any) => (res.data && res.data.data && res.data.data.data) ? res.data.data.data : []);
}

// Shared across helpdesk tabs so the same email is only requested once per page load.
const cache: {[email: string]: Promise<IMayordomoUser[]>} = {};

export function findUsersByEmail(email: string): Promise<IMayordomoUser[]> {
  const key = email.trim().toLowerCase();
  if (!cache[key]) {
    cache[key] = searchMayordomoUsers(key)
      // The search is a LIKE on the email: keep only exact matches (a@b.com must not match xa@b.com).
      .then((users) => users.filter((u) => (u.email || '').toLowerCase() === key))
      .catch(() => {
        // Don't cache failures: a later tab/ticket can retry.
        delete cache[key];
        return [];
      });
  }
  return cache[key];
}
